import './styles/graphic.scss';
import mapboxgl from 'mapbox-gl';

const drawMap = async (container, isMobile) => {
  const fetchOutlookData = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching outlook data:', error);
    }
  };

  const urls = {
    '6-10-day': 'https://ix.cnn.io/data/temp-outlook-map/us_temp_outlook_6_10_day.json',
    '8-14-day': 'https://ix.cnn.io/data/temp-outlook-map/us_temp_outlook_8_14_day.json',
  };

  const outlookData6to10 = await fetchOutlookData(urls['6-10-day']);
  const outlookData8to14 = await fetchOutlookData(urls['8-14-day']);

  // Set the initial state to 6-10 day data
  const initialOutlookData = outlookData6to10;
  const timestampString = `Forecast of the continental United States. Updates daily. Last issued on ${outlookData6to10.forecast_issued}.`;

  document.getElementById('timestamp').textContent = timestampString;
  const subhedDekElement = document.querySelector('.subhed.dek');
  if (subhedDekElement) {
    subhedDekElement.innerHTML = initialOutlookData.msg;
  }

  mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

  const optionsSm = {
    initZoom: 2,
    minZoom: 2,
    maxZoom: 7,
    center: [-95.5, 38.5],
    maxBounds: [[-180, 0], [-20, 52]],
  };

  const optionsLg = {
    initZoom: 3.2,
    minZoom: 2,
    maxZoom: 7,
    center: [-97, 38.5],
    maxBounds: [[-180, 0], [-20, 52]],
  };

  const options = isMobile ? optionsSm : optionsLg;

  const map = new mapboxgl.Map({
    container: container.node(),
    style: 'mapbox://styles/cnndigital/clxtf0b6p00q701puf7oz2ts9',
    center: options.center,
    zoom: options.initZoom,
    maxZoom: options.maxZoom,
    minZoom: options.minZoom,
    maxBounds: options.maxBounds,
  });

  map.dragRotate.disable();
  map.touchZoomRotate.disableRotation();
  map.scrollZoom.disable();

  if (!isMobile) {
    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });
    map.addControl(nav, 'top-left');
  }

  const addOutlookLayer = (sourceId, layerIdPrefix, sourceLayerName, url, visibility = 'none') => {
    map.addSource(sourceId, {
      type: 'vector',
      url,
    });

    const categories = ['Above', 'Below', 'Normal'];
    const colors = {
      Above: ['#FFE8DF', '#FFD3C3', '#F89A8B', '#E6655A', '#C52622', '#9A040B', '#670000'],
      Below: ['#DDF3FA', '#BBE6F8', '#8CC8F6', '#5194C3', '#166296', '#01446D', '#042853'],
      Normal: ['#e4e5e4', '#c4c4c4', '#a2a2a2', '#808080', '#666666'],
    };

    categories.forEach((cat) => {
      map.addLayer({
        id: `${layerIdPrefix}-${cat.toLowerCase()}`,
        type: 'fill',
        source: sourceId,
        'source-layer': sourceLayerName,
        layout: {
          visibility,
        },
        filter: ['match', ['get', 'cat'], [cat], true, false],
        paint: {
          'fill-color': [
            'interpolate',
            ['linear'],
            ['get', 'prob'],
            30, colors[cat][0],
            40, colors[cat][1],
            50, colors[cat][2],
            60, colors[cat][3],
            70, colors[cat][4],
            80, colors[cat][5] || colors[cat][4], // Handle 80% if defined
            90, colors[cat][6] || colors[cat][5] || colors[cat][4], // Handle 90% if defined
          ],
          'fill-opacity': cat === 'Normal' ? 0.7 : 0.9,
        },
      });
      map.moveLayer(`${layerIdPrefix}-${cat.toLowerCase()}`, 'jk-us-state-labels-v2');
    });
  };

  const updateLegend = (data) => {
    const legendContainer = document.querySelector('.legend-container');
    legendContainer.innerHTML = '';

    const categories = ['Above', 'Below', 'Normal'];
    const colors = {
      Above: ['#FFE8DF', '#FFD3C3', '#F89A8B', '#E6655A', '#C52622', '#9A040B', '#670000'],
      Below: ['#DDF3FA', '#BBE6F8', '#8CC8F6', '#5194C3', '#166296', '#01446D', '#042853'],
      Normal: ['#e4e5e4', '#c4c4c4', '#a2a2a2', '#808080', '#666666'],
    };

    const availableCategories = categories.filter(cat => data.some(d => d.cat === cat));

    availableCategories.forEach((cat) => {
      const categoryData = data.filter(d => d.cat === cat);
      const probs = [...new Set(categoryData.map(d => d.prob))].sort((a, b) => a - b);

      const section = document.createElement('div');
      section.className = 'legend-section';

      const label = document.createElement('div');
      label.className = 'legend-section-label';
      label.textContent = cat === 'Above' ? 'Above normal' : cat === 'Below' ? 'Below normal' : 'Near normal';
      section.appendChild(label);

      const itemsContainer = document.createElement('div');
      itemsContainer.className = 'legend-items';

      probs.forEach((prob, index) => {
        const legendItem = document.createElement('div');
        legendItem.className = 'legend-item';

        const colorBox = document.createElement('span');
        colorBox.style.backgroundColor = colors[cat][index];
        legendItem.appendChild(colorBox);

        if (!(cat === 'Normal' && probs.length === 1)) {
          const probLabel = document.createElement('div');
          probLabel.textContent = `${prob}%`;
          legendItem.appendChild(probLabel);
        }

        itemsContainer.appendChild(legendItem);
      });

      section.appendChild(itemsContainer);
      legendContainer.appendChild(section);
    });
  };

  map.on('load', () => {
    addOutlookLayer('6-10-day-outlook', '6-10-day', 'US temperature outlook - us temp outlook 6 10 day', 'mapbox://cnndigital.us_temp_outlook_6_10_day', 'visible');
    addOutlookLayer('8-14-day-outlook', '8-14-day', 'US temperature outlook - us temp outlook 8 14 day', 'mapbox://cnndigital.us_temp_outlook_8_14_day', 'none');

    // Move state boundaries and labels above the visualization layers
    map.moveLayer('state-innerlines');
    map.moveLayer('jk-us-outline-conus-v2');

    const forecastButtons = document.querySelectorAll('.forecast.button');

    const toggleLayerVisibility = (layerPrefix, visibility) => {
      ['above', 'below', 'normal'].forEach((cat) => {
        map.setLayoutProperty(`${layerPrefix}-${cat.toLowerCase()}`, 'visibility', visibility);
      });
    };

    const updateForecast = (event) => {
      const t = event.target.dataset.layer;
      toggleLayerVisibility('6-10-day', 'none');
      toggleLayerVisibility('8-14-day', 'none');
      toggleLayerVisibility(t, 'visible');
      forecastButtons.forEach(b => b.classList.remove('active'));
      event.target.classList.add('active');

      document.getElementById('timestamp').textContent = timestampString;

      if (t === '6-10-day') {
        if (subhedDekElement) {
          subhedDekElement.innerHTML = outlookData6to10.msg;
        }
        updateLegend(outlookData6to10.data);
      } else if (t === '8-14-day') {
        if (subhedDekElement) {
          subhedDekElement.innerHTML = outlookData8to14.msg;
        }
        updateLegend(outlookData8to14.data);
      }
    };

    forecastButtons.forEach((button) => {
      button.addEventListener('click', updateForecast);
    });

    document.querySelector('.forecast.button[data-layer="6-10-day"]').classList.add('active');
    document.getElementById('mapbtns').classList.add('show');

    // Initialize legend with 6-10 day outlook data
    updateLegend(outlookData6to10.data);

    // Ensure proper sizing for pym
    window.pymChild && window.pymChild.sendHeight();
  });
};

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
  } = props;

  container.html(''); // Clear previous content
  container.append('div')
    .attr('id', 'map')
    .style('width', `${initialWidth}px`)
    .style('height', `${initialHeight}px`);

  drawMap(container.select('#map'), isMobile); // Pass the D3 selection of the map div
}
